export const discountCardsList = [
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 1,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 2,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 3,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 4,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 5,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 6,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 7,
    },
    {
      amount: "-20 lei",
      type: "la orice cursa",
      discountText: "ISUP4444",
      id: 8,
    },
  ];